<template>
  <v-card min-width="21vw" light outlined>
    <v-card-title class="text-center" style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>Delete Coupon</h2></v-list-item-title>
        <v-spacer/>
        <v-icon class="icon" @click="close">fa-times</v-icon>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <p class="text-center">Do you want to delete the <b>{{ coupon.coupon_name }}</b> coupon?</p>
      <v-btn @click="deleteCoupon">Yes, Delete Coupon</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/payments';
export default {
  name: "DeleteCoupon",
  props: {
    coupon: Object,
  },
  methods: {
    deleteCoupon() {
      Repository.deleteCoupon(this.coupon.coupon_name).then((response) => {
        if(response.status < 400) {
          alert('Coupon deleted successfully!');
          this.$emit('deleted');
        }
      });
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>

</style>
